<header>
  <h2>{{ "settings.questions" | transloco }}</h2>

  <div class="config-row">
    <div
      class="ui toggle checkbox config-toggle"
      (click)="toggleConfigOperationMode(configOperations.export)"
    >
      <input type="checkbox" [ngModel]="configExportMode" />
      <label>{{ "settings.export-config-mode" | transloco }}</label>
    </div>
    @if (!isProductionMode) {
    <div
      class="ui toggle checkbox config-toggle"
      (click)="toggleConfigOperationMode(configOperations.delete)"
    >
      <input type="checkbox" [ngModel]="configDeleteMode" />
      <label>{{ "settings.delete-config-mode" | transloco }}</label>
    </div>
    }
  </div>

  <div id="filters">
    @if (taxYearOptions) {
    <app-search-dropdown
      label="{{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    } @if (configExportMode || configDeleteMode) {
    <div class="config-date">
      <input
        type="date"
        placeholder="From date"
        [(ngModel)]="configOperationDate"
        onkeydown="return false"
        [disabled]="loading"
        (change)="filterQuestionsOnDateChange()"
      />
    </div>
    } @if (configExportMode || configDeleteMode) {
    <button
      class="ui primary button background tiny config-button"
      (click)="openConfigOperationConfimationModal(configOperation)"
    >
      {{
        configExportMode
          ? ("settings.download-config" | transloco)
          : ("settings.delete-config" | transloco)
      }}
    </button>
    } @if (taxReturnTypeOptions && !configExportMode && !configDeleteMode) {
    <app-search-dropdown
      label="{{ 'settings.type' | transloco }}"
      [formGroup]="searchForm"
      [formCtrl]="taxReturnType"
      [listOptions]="taxReturnTypeOptions"
    ></app-search-dropdown>
    } @if (!configExportMode && !configDeleteMode) {
    <div id="question-type-filter">
      <label>{{ "settings.include" | transloco }}</label>
      <select
        class="ui fluid normal multi-select dropdown"
        multiple=""
        [(ngModel)]="questionTypeFilter"
        (ngModelChange)="onQuestionFiltersChanged()"
      >
        <option value="all">All</option>
        <option value="text">Text</option>
        <option value="number">Number</option>
        <option value="date picker">Date Picker</option>
        <option value="textarea">Textarea</option>
        <option value="drop down">Dropdown</option>
        <option value="radio">Radio</option>
        <option value="checkbox">Checkbox</option>
        <option value="image">Image</option>
        <option value="table">Table</option>
        <option value="file">File</option>
      </select>
    </div>
    } @if (!configExportMode && !configDeleteMode) {
    <div id="keyword-filter">
      <div class="ui left icon fluid input">
        <i class="search icon"></i>
        <input
          type="text"
          [(ngModel)]="questionSearch"
          (ngModelChange)="onQuestionFiltersChanged()"
          placeholder="{{ 'settings.search-questions' | transloco }}"
        />
      </div>
    </div>
    } @if (!configExportMode && !configDeleteMode && !isProductionMode) {
    <div
      id="create-new"
      class="ui primary background button"
      [routerLink]="['new']"
      [queryParams]="{ taxYear: taxYear?.value?.value }"
    >
      {{ "settings.new-question" | transloco }}
    </div>
    } @if (!configExportMode && !configDeleteMode && !isProductionMode) {
    <div
      id="create-backup"
      class="ui primary background button backup_button"
      (click)="createBackup()"
      [ngClass]="{ loading: creatingBackup }"
    >
      {{ "settings.Create-Backup" | transloco }}
    </div>
    }
  </div>
</header>

@if (loading) {
<div>
  <div class="ui active centered inline loader"></div>
</div>
} @if ((!loading && questions?.length == 0 && !configExportMode &&
!configDeleteMode) || (!loading && questionsForConfigExport?.length == 0 &&
(configExportMode || configDeleteMode))) {
<div id="no-results">{{ "settings.no-questions-found" | transloco }}</div>
} @if (!loading && questions?.length > 0 && !configExportMode &&
!configDeleteMode) {
@let filteredQuestions = questions | keyWord: ['id', 'question', 'APSRef',
'displayTag']:questionSearch | questionType: questionTypeFilter;
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      @if (config.featureFlags.aps) {
      <td width="200px" class="no-wrap">
        {{ "settings.aps-reference" | transloco }}
      </td>
      }
      <td></td>
    </tr>
  </thead>
  <tbody>
    @for (question of filteredQuestions | slice: ((questionPage - 1) * questionPageSize) : (questionPage * questionPageSize); track question) {
    <tr [routerLink]="[question?.id]">
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
        <div class="display-tag">{{ question?.displayTag }}</div>
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      @if (config.featureFlags.aps) {
      <td
        textTruncate
        [text]="question?.APSRef"
        [length]="60"
        title="{{ question?.APSRef }}"
      ></td>
      }
      <td align="right" class="btn">{{ "settings.go" | transloco }}</td>
    </tr>
    }
  </tbody>
</table>
<div class="pagination-row">
  <div class="pagination-summary">{{ filteredQuestions.length }} questions</div>
  <div class="pagination-actions">
    <button class="ui button tiny" [disabled]="questionPage <= 1"
      (click)="setQuestionPage(questionPage - 1, filteredQuestions.length)">Previous</button>
    @for (pageItem of getPaginationItems(questionPage, filteredQuestions.length, questionPageSize); track $index) {
      @if (pageItem !== '...') {
      <button class="ui button tiny pagination-number" [class.active]="pageItem === questionPage"
        (click)="setQuestionPage(pageItem, filteredQuestions.length)">{{ pageItem }}</button>
      } @else {
      <span class="pagination-ellipsis">...</span>
      }
    }
    <button class="ui button tiny"
      [disabled]="questionPage >= getTotalPages(filteredQuestions.length, questionPageSize)"
      (click)="setQuestionPage(questionPage + 1, filteredQuestions.length)">Next</button>
  </div>
  <div class="pagination-size">
    <label>Show</label>
    <select class="ui dropdown" [(ngModel)]="questionPageSize" (ngModelChange)="onQuestionPageSizeChanged()">
      @for (pageSize of pageSizeOptions; track pageSize) {
      <option [ngValue]="pageSize">{{ pageSize }}</option>
      }
    </select>
  </div>
</div>
} @if (!loading && questionsForConfigExport?.length > 0 && (configExportMode ||
configDeleteMode)) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td>
        @if (!configDeleteMode) {
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
        }
      </td>
      <td width="500px">{{ "settings.question" | transloco }}</td>
      <td width="200px" class="no-wrap">
        {{ "settings.type-of-field" | transloco }}
      </td>
      <td width="200px" class="no-wrap">
        {{ "settings.mandatory" | transloco }}
      </td>
      @if (config.featureFlags.aps) {
      <td width="200px" class="no-wrap">
        {{ "settings.aps-reference" | transloco }}
      </td>
      }
      <td>{{ "settings.created" | transloco }}</td>
      <td>{{ "settings.updated" | transloco }}</td>
      <td>{{ "settings.calc-plan-updated" | transloco }}</td>
    </tr>
  </thead>
  <tbody>
    @for (question of questionsForConfigExport | slice: ((configPage - 1) * configPageSize) : (configPage * configPageSize); track question) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="question.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>
        @if (showQuestionId) {
        <span>{{ question?.id }}.</span>
        } {{ question?.question }}
      </td>
      <td>{{ question?.questionType }}</td>
      <td>{{ question?.mandatory ? "Yes" : "No" }}</td>
      @if (config.featureFlags.aps) {
      <td
        textTruncate
        [text]="question?.APSRef"
        [length]="60"
        title="{{ question?.APSRef }}"
      ></td>
      }
      <td>{{ question?.displayCreatedAt }}</td>
      <td>{{ question?.displayUpdatedAt }}</td>
      <td>{{ question?.calcUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
<div class="pagination-row">
  <div class="pagination-summary">{{ questionsForConfigExport.length }} questions
    ({{ getSelectedConfigQuestionsCount() }} selected)</div>
  <div class="pagination-actions">
    <button class="ui button tiny" [disabled]="configPage <= 1"
      (click)="setConfigPage(configPage - 1, questionsForConfigExport.length)">Previous</button>
    @for (pageItem of getPaginationItems(configPage, questionsForConfigExport.length, configPageSize); track $index) {
      @if (pageItem !== '...') {
      <button class="ui button tiny pagination-number" [class.active]="pageItem === configPage"
        (click)="setConfigPage(pageItem, questionsForConfigExport.length)">{{ pageItem }}</button>
      } @else {
      <span class="pagination-ellipsis">...</span>
      }
    }
    <button class="ui button tiny"
      [disabled]="configPage >= getTotalPages(questionsForConfigExport.length, configPageSize)"
      (click)="setConfigPage(configPage + 1, questionsForConfigExport.length)">Next</button>
  </div>
  <div class="pagination-size">
    <label>Show</label>
    <select class="ui dropdown" [(ngModel)]="configPageSize" (ngModelChange)="onConfigPageSizeChanged()">
      @for (pageSize of pageSizeOptions; track pageSize) {
      <option [ngValue]="pageSize">{{ pageSize }}</option>
      }
    </select>
  </div>
</div>
}

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.question" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (question of selectedQuestions; track question) {
      <tr>
        <td>
          @if (showQuestionId) {
          <span>{{ question?.id }}.</span>
          } {{ question?.question }}
        </td>
        <td>{{ question.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedQuestions.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>

<div #configDeleteCheckModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-delete" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.question" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (question of selectedQuestions; track question) {
      <tr>
        <td>
          @if (showQuestionId) {
          <span>{{ question?.id }}.</span>
          } {{ question?.question }}
        </td>
        <td>{{ question.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedQuestions.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    #clicked
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="deleteConfig({ confirmed: false, event: $event })"
  >
    {{ "settings.delete" | transloco }}
  </button>
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>

<div #configDeleteConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  @if (configDeletePossible) {
  <h2>{{ "settings.confirm-deletion" | transloco }}</h2>
  }
  <p>
    {{
      configDeletePossible
        ? ("settings.Deletion-of-the-selected-config-is-possible-Following-items-will-be-deleted-would-you-like-to-continue"
          | transloco)
        : ("settings.Deletion-of-the-selected-config-is-not-possible-resolve-the-dependencies-and-try-again"
          | transloco)
    }}
  </p>
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.Questions" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.question" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (question of deleteQuestions; track question) {
        <tr>
          <td class="config-delete-id">{{ question.id }}</td>
          <td>
            <div>
              <div>{{ question.question }}</div>
              @if (question.parentDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Child-Questions" | transloco }}
                  </div>
                  <ul>
                    @for (pq of question.parentDependencies; track pq) {
                    <li class="config-delete-dep-row">
                      {{ pq.id }} - {{ pq.question }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (question.mandatoryParentDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Mandatory-Questions" | transloco }}
                  </div>
                  <ul>
                    @for (mpq of question.mandatoryParentDependencies; track
                    mpq) {
                    <li class="config-delete-dep-row">
                      {{ mpq.id }} - {{ mpq.question }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (question.calcDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Calc-Plans" | transloco }}
                  </div>
                  <ul>
                    @for (cp of question.calcDependencies; track cp) {
                    <li class="config-delete-dep-row">{{ cp }}</li>
                    }
                  </ul>
                </div>
              </div>
              } @if (configDeletePossible && question.questionDropdowns &&
              question.questionDropdowns.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.drop-downs" | transloco }}
                  </div>
                  <ul>
                    @for (dropdown of question.questionDropdowns; track
                    dropdown) {
                    <li class="config-delete-dep-row">
                      {{ dropdown.id }} - {{ dropdown.display }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (question.smartFormDependencies?.length) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-SmartForms-Message" | transloco }}
                  </div>
                  <ul>
                    @for (sf of question.smartFormDependencies; track sf) {
                    <li class="config-delete-dep-row">
                      {{ sf.smartFormName }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (configDeletePossible) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Total-Answers" | transloco }} -
                    {{ question.totalAnswers || 0 }}
                  </div>
                </div>
              </div>
              }
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if (deleteSubgroups && deleteSubgroups.length) {
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.Subgroups" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.name" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (sg of deleteSubgroups; track sg) {
        <tr>
          <td class="config-delete-id">{{ sg.id }}</td>
          <td>{{ sg.name }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @if (deleteSubcategories && deleteSubcategories.length) {
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.Subcategories" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.name" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (sc of deleteSubcategories; track sc) {
        <tr>
          <td class="config-delete-id">{{ sc.id }}</td>
          <td>{{ sc.name }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @if (deleteCategories && deleteCategories.length) {
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">
      {{ "settings.Categories" | transloco }}
    </h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th class="config-delete-id">{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.name" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (category of deleteCategories; track category) {
        <tr>
          <td class="config-delete-id">{{ category.id }}</td>
          <td>{{ category.name }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @if (configDeletePossible) {
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="deleteConfig({ confirmed: true, event: $event })"
  >
    {{ "settings.confirm" | transloco }}
  </button>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedQuestions.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>
